<template>
  <div class="question-answer-accordion">
    <button
      type="button"
      :class="[
        'question-answer-accordion__question',
        {
          'question-answer-accordion__question--collapsed': collapsed,
        },
      ]"
      @click.prevent="handleCollapse()"
    >
      <slot name="question"></slot>
    </button>

    <div v-show="collapsed" class="question-answer-accordion__answer">
      <slot name="answer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionAnswerAccordion',
  data() {
    return {
      collapsed: false,
    };
  },
  methods: {
    handleCollapse() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-answer-accordion {
  $block-selector: &;
  $breakpoint: $breakpoint-s;
  $border-color: $color-gray-iron;
  $border: solid $border-color 0.0625em;

  border: $border;
  border-bottom: none;

  &:last-child {
    border: $border;
  }

  &__question {
    position: relative;
    padding: 1.5em 1em;
    font-size: 1.125em;
    color: $color-gray-dove;
    cursor: pointer;
    background-color: transparent;
    border: none;
    width: 100%;
    text-align: left;

    &::after {
      @extend %icon;
      @extend %icon--arrow-fill-bottom;
      position: absolute;
      top: 50%;
      right: 0.3em;
      transform: translate3d(0, -50%, 0);
      transition: transform 0.2s;

      @include breakpoint($breakpoint) {
        right: 2em;
      }
    }

    &--collapsed {
      &::after {
        transform: translate3d(0, -50%, 0) rotate(180deg);
      }
    }

    @include on-event {
      &:not(#{$block-selector}__question--collapsed) {
        &::after {
          transform: translate3d(0, -50%, 0) rotate(10deg);
        }
      }
    }
  }

  &__answer {
    position: relative;
    padding: 1.5em 1em 2em;
    margin-bottom: 0;
    font-size: 0.875em;

    &::before {
      content: '';
      display: inline-block;
      width: calc(100% - 4em);
      height: 0.0625em;
      background-color: $border-color;
      position: absolute;
      top: 0;
      left: 50%;
      right: 0;
      transform: translate3d(-50%, 0, 0);
    }
  }
}
</style>
